import { useState } from "react";
import { useSelector } from "react-redux";

import { COMPLAINTS_HEADER_OPTIONS } from "../../utils/ComplaintsTables.config";
import MobileActionHeader from "../../../../components/UI/headingsUI/MobileActionHeader";
import FilterSearch from "../../../../components/common/FilterSearch";
import { COMPLAINT_SEARCH_OPTIONS } from "../../utils/complaintFilter.config";
import { complaintFilterOptions } from "../../utils/complaintFilter.config";
import ComplaintViewDialog from "../complaintDialog/ComplaintViewDialog";
import ImageSlider from "../../../../components/UI/viewDialogs/ImageSlider";
import UsePermissionsClaim from "../../../../CustomHooks/UsePermissionsClaim";
import { filterTableColumns } from "../../../../utils/tableHeaderConfigh";
import { adminRoles } from "../../../../utils/adminRoles";
import ComplaintsTable from "./ComplaintsTable";
import { formatComplaintExcelData } from "../../utils/excelFormatters";

const ComplaintListContent = ({ complaintsData }) => {
  const [viewDialogDetails, setViewDialogDetails] = useState({});
  const [imageSliderPics, setImageSliderPics] = useState([]);
  const [imageSliderCurrentIndex, setImageSliderCurrentIndex] = useState();
  const copyComplaintData = useSelector((state) => state.data.copyData);
  const { checkPermission } = UsePermissionsClaim();
  const permAddComplaint = checkPermission("add_complaint");
  const permAddVisit = checkPermission("add_visit");

  const filterComplaintHeadList = filterTableColumns({
    headList: COMPLAINTS_HEADER_OPTIONS,
    removeIfNoPermission: [
      {
        key: "Action",
        condition: permAddVisit,
      },
    ],
    roleConfig: {
      Supervisor: adminRoles,
    },
  });

  // ...............get  excel data............
  const excelData = formatComplaintExcelData(copyComplaintData);
  const excelConfig = {
    data: excelData,
    fileName: "Complaints_Report",
    sheetName: "Complaints",
  };

  const closeViewDialog = () => {
    setViewDialogDetails({ ...viewDialogDetails, open: false });
  };

  const openImageSlider = (Pics) => {
    closeViewDialog();
    setImageSliderPics(Pics);
  };

  const closeImageSlider = () => {
    setImageSliderPics([]);
    setViewDialogDetails({ ...viewDialogDetails, open: true });
  };

  return (
    <>
      <MobileActionHeader
        title="Complaints"
        navigate={"/complaint/add"}
        btnText={permAddComplaint ? "Add Complaint" : undefined}
      />
      <FilterSearch
        categories={complaintFilterOptions}
        searchCategories={COMPLAINT_SEARCH_OPTIONS}
        addBtnNavigation={"/complaint/add"}
        addBtnText={permAddComplaint ? "Add Complaint" : undefined}
        excelConfig={excelConfig}
      />
      <ComplaintsTable
        filterComplaintHeadList={filterComplaintHeadList}
        setViewDialogDetails={setViewDialogDetails}
      ></ComplaintsTable>
      {viewDialogDetails?.open && (
        <ComplaintViewDialog
          closeDialog={closeViewDialog}
          viewDetails={viewDialogDetails.data}
          openImageSlider={openImageSlider}
          setImageSliderCurrentIndex={setImageSliderCurrentIndex}
          setComplaintViewDetails={setViewDialogDetails}
        />
      )}
      {imageSliderPics.length !== 0 && (
        <ImageSlider
          title="Complaint Photos"
          images={imageSliderPics}
          imageSliderCurrentIndex={imageSliderCurrentIndex}
          closeDialogBox={closeImageSlider}
        />
      )}
    </>
  );
};
export default ComplaintListContent;
